var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "PopUp",
    {
      attrs: {
        title: _vm.title,
        size: _vm.size,
        "ok-text": "Bestätigen",
        "ok-disabled": _vm.confirmDisabled,
        "ok-loading": _vm.confirmLoading,
        closable: _vm.closable
      },
      on: {
        ok: function($event) {
          return _vm.$emit("confirm")
        },
        hidden: function($event) {
          return _vm.$emit("hidden")
        }
      }
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }